import { render, staticRenderFns } from "./editMainContact.vue?vue&type=template&id=7dc972fa&lang=pug"
import script from "./editMainContact.vue?vue&type=script&lang=js"
export * from "./editMainContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports